var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-layout-card", {
    attrs: {
      "is-active": _vm.isActive,
      layout: _vm.layout,
      "menu-options": _vm.menuOptions,
      "can-select-on-click": !_vm.isActive,
      "show-bookmark-button": true,
      "show-menu-button": true,
      "show-warning": _vm.showWarning,
    },
    on: {
      select: function ($event) {
        return _vm.$emit("select", $event)
      },
      bookmark: function ($event) {
        return _vm.$emit("bookmark", $event)
      },
      reset: function ($event) {
        return _vm.$emit("reset", $event)
      },
      delete: function ($event) {
        return _vm.$emit("delete", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }